import type { BoggleGameModeId } from '~/boggle/gameModes/types'
import { normalizeSeed, nextInteger } from '~/boggle/engine/core'
import { pickWeightedEntry } from '~/boggle/lib/challenge/random'
import {
  BOGGLE_CHALLENGE_CONFIGURATION_DEFINITIONS,
  isBoggleChallengeConfigurationEnabled,
  type BoggleChallengeConfigurationId,
} from './registry'

export function pickBoggleChallengeCatalogFromRollSeed(seed: number | string): {
  configurationId: BoggleChallengeConfigurationId
  gameModeId: BoggleGameModeId
} {
  const normalized = normalizeSeed(seed)
  const rollPool = BOGGLE_CHALLENGE_CONFIGURATION_DEFINITIONS.filter(
    isBoggleChallengeConfigurationEnabled,
  )
  const picked = pickWeightedEntry(
    [...rollPool],
    normalizeSeed(`challenge-catalog:${normalized}`),
  )

  if (picked === null) {
    throw new Error('No weighted challenge configurations available in catalog')
  }

  const configuration = picked.entry
  const gameModeIds: readonly BoggleGameModeId[] = configuration.gameModeIds
  if (gameModeIds.length === 0) {
    throw new Error(`Challenge configuration ${configuration.id} lists no game modes`)
  }

  const modePick = nextInteger(
    normalizeSeed(`${configuration.id}:challenge-mode:${normalized}`),
    gameModeIds.length,
  )

  return {
    configurationId: configuration.id,
    gameModeId: gameModeIds[modePick.value]!,
  }
}

export function pickBoggleChallengeGameModeIdFromSeed(seed: number | string): BoggleGameModeId {
  return pickBoggleChallengeCatalogFromRollSeed(seed).gameModeId
}
